module.exports = "/_next/static/images/ga-e554f938225964e2f0e68468023dd5eb.svg";